import { useInView } from 'react-intersection-observer';
import { useRouter } from 'next/navigation';

import ImageSlider from './ImageSlider';
import ContentEntityList from '@/components/containers/ContentEntityList';
import QuizzesBodyItem from '@/app/(matches)/matches/components/QuizzesBodyItem';
import React from 'react';
import CommunitiesHorizontalList from '@/app/community/components/CommunitiesHorizontalList';
import FastUseContainer from './FastUse/FastUseContainer';
import useAuth from '@/context/auth/useAuth';

function FlexComponent({ content, className }: { content: any; className?: string }) {
    let Component: React.ElementType | null = null;
    let props = {};
    const { section_type: sectionType, content_type: contentType, cards } = content;
    const { userIsLoggedIn, setInAppLoginModalIsOpen } = useAuth();
    const router = useRouter();

    const { ref: inViewRef, inView } = useInView({
        threshold: 0.1
    });

    switch (sectionType.toLowerCase()) {
        case 'slider': {
            Component = ImageSlider;
            break;
        }
        case 'list': {
            // todo: handle story list, temporarily omitted
            if (contentType === 'Community') {
                return <CommunitiesHorizontalList list={cards} bigCardMode />;
            }
            props = {
                isSeries: false,
                // isResumable: false,
                contentType,
                className
            };
            Component = ContentEntityList;
            break;
        }
        case 'fast use': {
            return (
                <div ref={inViewRef}>
                    <FastUseContainer data={content} isInView={inView} />
                </div>
            );
        }

        case 'single': {
            switch (contentType.toLowerCase()) {
                case 'quiz': {
                    Component = QuizzesBodyItem;
                    props = {
                        item: content?.cards[0].media_object,
                        onClick: () => {
                            if (userIsLoggedIn) {
                                router.push(
                                    `/matches/${content?.cards[0].media_object.match.id}/quiz/${content?.cards[0].media_object.id}`
                                );
                            } else {
                                setInAppLoginModalIsOpen({
                                    isOpen: true,
                                    toGoUrl: `/matches/${content?.cards[0].media_object.match.id}/quiz/${content?.cards[0].media_object.id}`,
                                    previousUrl: null
                                });
                            }
                        }
                    };
                    break;
                }
                case 'banner': {
                    Component = ContentEntityList;
                    break;
                }

                default: {
                    break;
                }
            }
            break;
        }

        default: {
            break;
        }
    }

    if (Component) return <Component data={content} {...props} />;

    return null;
}

export default FlexComponent;
